export const GRAY_ACCORDION = '#EEEEF0'
export const BLUE_ACCORDION = '#ccc'
export const ALT_2 = '#edf7fe'
export const ALT_3 = '#e2efd9'
